<div [ngClass]="{'w-100 partial-height-mobile': !viewportService.isLargeViewPort(), 'h-100 width-400px': viewportService.isLargeViewPort()}"
     class="position-absolute overflow-x-hidden background-white z-max">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="row position-fixed background-light-gray border-bottom border-dark-subtle p-3 m-0 z-max d-flex align-items-center height-details-header">
        <div (click)="back()"
             class="col-1 pt-4 pb-4 btn text-reset m-auto rounded-2"
             type="button">
            <i class="fa-solid fa-chevron-left color-secondary-information m-auto"></i>
        </div>
        <div class="col-2 m-0 d-flex justify-content-center">
            <app-water-point-svg/>
        </div>
        @if (!loading) {
            <div class="col-8 m-0">
                <div class="fw-bold">{{ asset()?.name || '-' }}</div>
                <div class="{{ statusMessageColorClass() }}">{{ statusMessage() }}</div>
                <div class="{{valueColorClass()}} fw-bold">Level: {{ percentage }}</div>
            </div>
        }
        <div (click)="close()"
             class="col-1 pt-4 pb-4 btn text-reset m-auto rounded-2"
             type="button">
            <i class="fa-solid fa-x color-secondary-information m-auto"></i>
        </div>
    </div>
    <div class="margin-top-details-header gap-3 d-flex flex-column ps-3 pe-3">
        <div>
            <div class="m-0 fw-bold">Temperature</div>
            @if (loadingTemperatureData()) {
                <div class="m-1">
                    Loading...
                </div>
            } @else if (noTemperatureDataAvailable()) {
                <div class="m-1">
                    No data available
                </div>
            } @else {
                <div class="m-1 temperature gap-2">
                    <i class="fa-solid fa-temperature-quarter"></i>
                    <div class="temperature-reading">
                        {{ temperature() | number: '1.1-1' }}{{ temperatureUnit() }}
                        @if (lastSeenTemperatureMessage()) {
                            ({{ lastSeenTemperatureMessage() }})
                        }
                    </div>
                </div>
            }
        </div>
        <div class="m-0 fw-bold">Water level</div>
        @if (loadingWaterLevelData()) {
            <span class="text-center">Loading...</span>
        } @else if (noWaterLevelDataAvailable()) {
            <span class="text-center">No data available</span>
        } @else {
            <div class="w-100">
                <ngx-charts-line-chart
                        [results]="dataset"
                        [scheme]="scheme"
                        [showXAxisLabel]="false"
                        [timeline]="false"
                        [xAxis]="false"
                        [yAxisTickFormatting]="formatY"
                        [yAxis]="true"
                        [yScaleMax]="yScaleMax"
                        [yScaleMin]="yScaleMin">
                </ngx-charts-line-chart>
            </div>
            <div class="row mt-1 mb-3 graph-date-p pe-3 d-flex justify-content-between">
                @for (date of xAxisTicks; track date) {
                    <span class="col dates-height vertical-text graph-label">{{ date }}</span>
                }
            </div>
        }
        <div>
            <div class="col">
                <button aria-controls="waterPointDateRange"
                        aria-expanded="false"
                        class="btn btn-info btn-info-shadow dropdown-toggle w-100"
                        data-bs-target="#waterPointDateRange"
                        data-bs-toggle="collapse"
                        [disabled]="loading || noWaterLevelDataAvailable()"
                        type="button">
                    {{ selectedDateRangeName || "Select date range" }}
                </button>
                <div class="collapse"
                     id="waterPointDateRange">
                     @for (dateRange of selectableDateRanges; track dateRange) {
                        <div (click)="fetchData(dateRange)"
                            aria-controls="waterPointDateRange"
                            class="btn card m-1"
                            data-bs-target="#waterPointDateRange"
                            data-bs-toggle="collapse">{{ dateRange }}
                        </div>
                     }
                </div>
            </div>
        </div>
        <app-generic-button
            (click)="toggleCustomize('/main/customize-water-point')"
            description="Customize water point"
            [alwaysShowText]="true"
            [buttonText]="'Customize'"
            [disabled]="loading || !canBeAltered"
            [primaryIcon]="'fa-solid fa-gear'"></app-generic-button>
        <app-generic-button
            (click)="delete()"
            description="Delete water point"
            [alwaysShowText]="true"
            [buttonClass]="'btn-danger btn-danger-shadow'"
            [buttonText]="'Delete'"
            [disabled]="loading || !canBeDeleted || deviceAssociations().length > 1"
            [primaryIcon]="'fa-solid fa-trash-can'"/>
      <app-asset-metadata [id]="asset()?.id" [relatedDeviceAssociations]="deviceAssociations()"/>
    </div>
</div>
